import { Skeleton, Stack } from '@mui/material';

export const LoadingOverlay = () => {
  const skeletonRow = (
    <Stack direction={'row'} width={'100%'} gap={'1rem'}>
      <Skeleton sx={{ flex: 1 }} />
      <Skeleton sx={{ flex: 8 }} />
      <Skeleton sx={{ flex: 2 }} />
    </Stack>
  );

  return (
    <Stack
      display={'flex'}
      height={'100%'}
      width={'100%'}
      alignItems={'center'}
      justifyContent={'center'}
      gap={'1.25rem'}
      padding={'1rem 1.5rem'}
    >
      {skeletonRow}
      {skeletonRow}
      {skeletonRow}
      {skeletonRow}
    </Stack>
  );
};
